import React, { useState } from "react"
import { Table } from "@bitcine/cs-theme"
import uniqBy from "lodash.uniqby"
import Search from "@components/search/"

const AttachedUsers = ({ allUsers, attachedUserIDs, roleUsers, parentUsers, updateUsersAccess }) => {
  const [search, setSearch] = useState("")
  const attachedUsers = allUsers.filter(user => attachedUserIDs?.includes(user._id))
  const allMembersWithAccess = uniqBy([...roleUsers, ...parentUsers, ...attachedUsers], user => user._id).map(user => {
    return { ...user, role_name: allUsers.find(opt => opt._id === user._id)?.role_name || "No Role" }
  })
  const filteredMembersWithAccess = allMembersWithAccess.filter(user => {
    if (!search.length) {
      return true
    }
    return user.full_name.toLowerCase().includes(search.toLowerCase()) || user.email.toLowerCase().includes(search.toLowerCase())
  })
  const hasDirectAccess = userId => {
    return attachedUsers.find(member => member._id === userId) !== undefined
  }
  const removeUser = user => {
    updateUsersAccess(attachedUsers.filter(u => u._id !== user._id).map(u => u._id))
  }
  return (
    <div>
      <Search
        visible
        onChange={e => setSearch(e.target.value)}
        onCancel={() => setSearch("")}
        value={search}
        placeholder='Search for a user...' />
      <Table
        className='my3'
        widths={["auto", 220, 180, 130, 130, 55]}
        header={{
          columns: [{ text: "Name" }, { text: "Email" }, { text: "Role" }, { text: "Status" }, { text: "Access" }, { text: "" }]
        }}
        body={{
          data: filteredMembersWithAccess,
          row: {
            compact: true,
            render: [
              data => data.full_name,
              data => <div className='truncate'><a title={data.email}>{data.email}</a></div>,
              data => data.role_name,
              data => data.status,
              data => roleUsers.find(user => user._id === data._id)
                ? "Via Role"
                : parentUsers.find(user => user._id === data._id)
                  ? "Via Parent"
                  : "Attached Directly",
              data => hasDirectAccess(data._id) ? <button
                data-tooltip={'Revoke access'}
                className='tooltip cs-button link material-icons'
                style={{ color: 'gray' }}
                onClick={() => removeUser(data)}>do_not_disturb_on</button>
                : null
            ]
          },
          empty: {
            title: "No team members",
            text: search.length ? "Try your search again!" : "Invite a team member to get started",
            icon: "people"
          }
        }} />
    </div>
  )
}

export default AttachedUsers